import Button from '../ui-components/Button'
import { MUTUAL_FUND_DETAIL_IMAGE_URL } from '../../constants'
import { trackEvent } from '../../utils/appBridge'
import { EventNames } from '../../types/misc.types'
import { useMetaDataContext } from '../../state-management/contexts/MetaDataContext'
import { postCTA } from '../../utils/appBridge'

type RankSectionPropTypes = {
  ranksType: 'ROLLING' | 'TRAILING'
}

export const LockedRankSection = ({ ranksType }: RankSectionPropTypes) => {
  const { data, isin } = useMetaDataContext()

  const handleClick = () => {
    trackEvent({
      eventName: EventNames.ButtonTap,
      payload: {
        eventId: 'Elite_Lock',
        ScreenName: ranksType === 'ROLLING' ? `MF_L2_Rolling_Returns_Rank` : `MF_L2_Trailing_Returns_Rank`,
        screenType: 'MF_L2',
        fundName: isin
      }
    })
    if (data?.eliteIconCta) postCTA(JSON.stringify(data?.eliteIconCta))
  }
  return (
    <div className='w-full flex flex-col'>
      <div className='w-full'>
        <RankGraphLocked ranksType={ranksType} />
      </div>
      <div className='pt-6 text-[#6A6E6E] text-[13px] leading-[140%] px-1'>
        Unlock Rank Trends for {ranksType?.toLowerCase()} returns and more with PowerUp Elite
      </div>
      <div className='w-full pt-4 pb-6'>
        <Button buttonClassName='min-h-12 text-[14px] font-[500]' isFullWidth onClick={handleClick}>
          View all Elite Benefits
        </Button>
      </div>
    </div>
  )
}

const RankGraphLocked = ({
  errorText,
  ranksType
}: {
  errorText?: string
  ranksType: RankSectionPropTypes['ranksType']
}) => {
  const { isin, data } = useMetaDataContext()
  const handleClick = () => {
    trackEvent({
      eventName: EventNames.UserClicked,
      payload: {
        eventId: 'Elite_Lock',
        ScreenName: ranksType === 'ROLLING' ? `MF_L2_Rolling_Returns_Rank` : `MF_L2_Trailing_Returns_Rank`,
        screenType: 'MF_L2',
        fundName: isin
      }
    })
    if (data?.eliteIconCta) postCTA(JSON.stringify(data?.eliteIconCta))
  }
  return (
    <div className='w-full h-full rounded-xl overflow-hidden'>
      <div className='flex flex-col relative' style={{ height: 'calc(100% - 30px)' }}>
        <div className='absolute h-full w-full flex items-center justify-center'>
          <div
            onClick={handleClick}
            className='bg-white rounded-[20px] font-[500] w-max px-5 py-1 text-13 flex gap-2 items-center justify-center'
          >
            <div>
              <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                <path
                  d='M6.21429 5.375V6.5H9.78571V5.375C9.78571 4.33906 8.98661 3.5 8 3.5C7.01339 3.5 6.21429 4.33906 6.21429 5.375ZM4.78571 6.5V5.375C4.78571 3.51172 6.22545 2 8 2C9.77455 2 11.2143 3.51172 11.2143 5.375V6.5H11.5714C12.3594 6.5 13 7.17266 13 8V12.5C13 13.3273 12.3594 14 11.5714 14H4.42857C3.64063 14 3 13.3273 3 12.5V8C3 7.17266 3.64063 6.5 4.42857 6.5H4.78571Z'
                  fill='#3D3D3D'
                />
              </svg>
            </div>
            <div>{errorText ?? 'Unlock with Elite'}</div>
          </div>
        </div>
        <div className='w-full'>
          <img src={`${MUTUAL_FUND_DETAIL_IMAGE_URL}/rank-boxes.svg`} className='w-full' />
        </div>
      </div>
    </div>
  )
}
